if (!window.beaePageJS) {
                                    window.beaePageJS = [];
                                }
                                let jsHandle_6383cf6a053e15446f2b8722 = () => {

                    if (document.querySelector('.beae-y8nvnzpj:not([data-beae-bind])')) {
                        (function() {!this.$el||!this.$el.querySelector(".beae-section-background-video")||typeof handleVideoBg=="undefined"||!this.isLive||(handleVideoBg.bind(this)(),window.addEventListener("resize",handleVideoBg.bind(this)))}).call({
                            $el: document.querySelector('.beae-y8nvnzpj:not([data-beae-bind])'),
                            
                            id: 'beae-y8nvnzpj',
                            isLive: true
                        });
                        document.querySelector('.beae-y8nvnzpj:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                    }
                
                    if (document.querySelector('.beae-d271s923:not([data-beae-bind])')) {
                        (function() {!this.$el||!this.$el.querySelector(".beae-section-background-video")||typeof handleVideoBg=="undefined"||!this.isLive||(handleVideoBg.bind(this)(),window.addEventListener("resize",handleVideoBg.bind(this)))}).call({
                            $el: document.querySelector('.beae-d271s923:not([data-beae-bind])'),
                            
                            id: 'beae-d271s923',
                            isLive: true
                        });
                        document.querySelector('.beae-d271s923:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                    }
                
                    if (document.querySelector('.beae-o0ulyjwf:not([data-beae-bind])')) {
                        (function() {!this.$el||!this.$el.querySelector(".beae-section-background-video")||typeof handleVideoBg=="undefined"||!this.isLive||(handleVideoBg.bind(this)(),window.addEventListener("resize",handleVideoBg.bind(this)))}).call({
                            $el: document.querySelector('.beae-o0ulyjwf:not([data-beae-bind])'),
                            
                            id: 'beae-o0ulyjwf',
                            isLive: true
                        });
                        document.querySelector('.beae-o0ulyjwf:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                    }
                }
                                if (window.beaejQuery) {
                                    jsHandle_6383cf6a053e15446f2b8722()
                                } else {
                                    window.beaePageJS.push(jsHandle_6383cf6a053e15446f2b8722)
                                }